module.exports = __webpack_public_path__ + "static/media/mandat.6ee3a6be.webp";